import BannerSettingsTable from './BannerSettingsTable';

export default BannerSettingsTable;
